export default __webpack_public_path__ + "static/media/NCT.8e34f7cb.svg";